import { BodyFastAction } from 'Reducers'
import { ActionType } from './ActionTypes'

export type PaymentStep =
 | 'payment'
 | 'ebook'
 | 'upsell'

export interface PaymentState {
  products: Products
}

export interface ILoadProducts { type: ActionType.LOAD_PRODUCTS, groupId: SubscriptionGroupId, isRetry?: boolean }
export interface IMergeProducts { type: ActionType.MERGE_PRODUCTS, groupId: SubscriptionGroupId, prices: IStripePrice[] }
export interface IUpdateSubscription { type: ActionType.UPDATE_SUBSCRIPTION, priceId: string, stepId: SubscriptionUpdateStepId }
export interface IUpdateSubscriptionOfferDecline { type: ActionType.DECLINE_UPDATE_SUBSCRIPTION_OFFER, stepId: SubscriptionUpdateStepId }
export interface IPurchaseEbookAction { type: ActionType.PURCHASE_EBOOK, priceId: string, currency: string }
export interface IResolveMorEbookPurchaseAction { type: ActionType.RESOLVE_MOR_EBOOK_PURCHASE, checkoutSessionId?: string }
export interface IDeclineEbookPurchaseAction { type: ActionType.DECLINE_EBOOK_PURCHASE }
// subscriptionExpected is false where nothing fetches the subscription first, so a
// null one there is the normal path rather than a degraded fetch.
export interface ICommitPaymentStep { type: ActionType.COMMIT_PAYMENT_STEP, stepId: PaymentStep, subscriptionExpected?: boolean }

export type PaymentAction =
  | ILoadProducts
  | IMergeProducts
  | IUpdateSubscription
  | IUpdateSubscriptionOfferDecline
  | IPurchaseEbookAction
  | IResolveMorEbookPurchaseAction
  | IDeclineEbookPurchaseAction
  | ICommitPaymentStep

const EMPTY_PRODUCTS = {}

const INITIAL_STATE: PaymentState = {
  products: EMPTY_PRODUCTS
}

export const PaymentReducer = (state: PaymentState = INITIAL_STATE, action: BodyFastAction): PaymentState => {
  switch (action.type) {
    case ActionType.MERGE_PRODUCTS:
      return {
        ...state,
        products: {
          ...state.products,
          [action.groupId]: action.prices
        }
      }

    default:
      return state
  }
}
